/*包含 n 个 action type 常量名称的模块
 */

export const READ_DOMAIN = 'read_domain' // 读取当前域名
export const SET_DOMAIN = 'set_domain' // 设置domain
export const SET_BREADCRUMBARR = 'set_breadcrumbarr' // 设置domain

export const SET_ISLOGIN = 'set_islogin' // 改变登陆状态

export const SET_ISMODALVISIBLE = 'set_ismodalvisible' // 改变登陆状态

export const SET_CARTCOUNT = 'set_cartcount' // 改变购物车数量

export const SET_CARTLIST = 'set_cartlist' // 保存当前用户购物车列表

export const SET_ISSELECTCARTBRANDALLGOOD = 'set_isselectcartbrandallgood' // 是否选中cart good

export const SET_ISSELECTCARTGOOD = 'set_isselectcartgood' // 修改被商品是否被选中

export const SET_CARTSELECTTOTAL = 'set_cartselecttotal' // 修改当前购物车选中的条数

export const SET_CARTSUM = 'set_cartsum' // 修改购物车选中的商品总价格

export const SET_CARTISALLSELECT = 'set_cartisallselect' // 购物车是否全选

export const SET_CARTLISTGOODTOTALL = 'set_cartlistgoodtotall' // 修改商品列表中的商品条数

export const SET_ISSHOWMOREADDRESS = 'set_isshowmoreaddress' // 设置购物车确认页更多地址是否展示

export const SET_ADDRESSMODALSTATUS = 'set_addressmodalstatus' // 设置地址模拟框状态

export const SET_CURRADDRESSMODALDATA = 'set_curraddressmodaldata' // 设置当前地址模拟框的数据

export const SET_SUBMITORDERDATA = 'set_submitorderdata' // 提交订单时所需要的数据

export const SET_ISSUBMITORDER = 'set_issubmitorder' // 是否提交订单

export const SET_SUBMITORDERINVOICE = 'set_submitorderinvoice' // 设置订单数据中的发票信息

export const SET_SUBMITORDERREMARK = 'set_submitorderremark' //设置订单数据中的备注信息

export const SET_SUBMITORDERGOOD = 'set_submitordergood' // 设置订单数据中的商品信息

export const SET_SUBMITORDERADDRESSID = 'set_submitorderaddressid' // 设置提交订单数据中的地址信息Id

export const SET_SUBMITORDERSTATUS = 'set_submitorderstatus' // 设置提交订单数据中的订单状态

export const SET_SUBMITORDERTOTAL = 'set_submitordertotal' // 设置提交订单数据中的商品总价格

export const SET_VIP = 'set_isvip' // 改变登陆状态

export const SET_CONFIGDATA = 'set_config_data' //config数据

export const SET_IS_YH_SITE = 'SET_IS_YH_SITE' //config数据

export const SET_INDEX_DATA = 'set_index_data' //index数据

export const ADD_GOOD_COMPARE = 'add_good_compare' //添加商品对比数据
export const REMOVE_GOOD_COMPARE = 'remove_good_compare' //移除商品对比数据
export const CLEAR_GOOD_COMPARE = 'clear_good_compare' //清除商品对比数据
export const INIT_GOOD_COMPARE = 'init_good_compare' // 初始化商品对比数据
export const SET_GOOD_COMMENT_TOTAL = 'set_good_comment_total' // 初始化商品评论数据

export const INIT_GOOD_COMPARE_ATTR = 'init_good_compare_attr' // 初始化商品对比数据

export const SET_GLOBAL_USER_INFO = 'SET_GLOBAL_USER_INFO'
